import React from 'react';

interface ContentCardProps {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg';
  shadow?: 'sm' | 'md' | 'lg';
}

export const ContentCard: React.FC<ContentCardProps> = ({
  title,
  subtitle,
  children,
  actions,
  className = '',
  padding = 'md',
  shadow = 'md'
}) => {
  const getPaddingClass = () => {
    switch (padding) {
      case 'sm':
        return 'p-5';
      case 'lg':
        return 'p-10';
      default:
        return 'p-7';
    }
  };

  const getShadowClass = () => {
    switch (shadow) {
      case 'sm':
        return 'shadow-sm';
      case 'lg':
        return 'shadow-lg';
      default:
        return 'shadow';
    }
  };

  return (
    <div className={`bg-white rounded-lg border ${getShadowClass()} ${className}`}>
      {(title || actions) && (
        <div className="flex items-center justify-between border-b border-gray-200 px-7 py-5">
          <div>
            {title && (
              <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
            )}
            {subtitle && (
              <p className="text-sm text-gray-600 mt-2">{subtitle}</p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-3">
              {actions}
            </div>
          )}
        </div>
      )}
      <div className={`${getPaddingClass()} space-y-5`}>
        {children}
      </div>
    </div>
  );
};
